import ajax from '@/utils/request'
export default {  
  /**
  * 登录注册流程中获取有活动的专栏
  * @see https://yapi.geekbang.org/project/116/interface/api/19751
  */
 getActivityColumn () {
   return ajax({
     url: 'public/v1/activity/column_list'
   })
 }
}
